<template>
    <li class="forecastItem grid gg1 gc6 gr-height-2">
        <span class="gc-start-1 gc-end-3 flex items-center">{{ weekday }}</span>
        <span class="tc">
            <svgicon :name="forecastItem.icon"
                :alt="forecastItem.icon" class="forecastItem__icon"
                :color="$root.getColorForIcon(forecastItem.icon)"></svgicon>
        </span>
        <span class="tc flex items-center">
            <span v-if="precipProbability" class="blue">{{ precipProbability }}</span>
        </span>
        <span class="flex justify-end items-center">{{ temperature }}</span>
        <span class="flex justify-end items-center gray">{{ temperatureMin }}</span>
    </li>
</template>

<script>

export default {
    name: 'ForecastItem',
    props: {
        forecastItem: Object,
    },
    computed: {
        temperature() {
            return Math.round(this.forecastItem.temperatureMax);
        },
        temperatureMin() {
            return Math.round(this.forecastItem.temperatureMin);
        },
        weekday() {
            const formatter = new Intl.DateTimeFormat(this.$root.lang, {
                weekday: 'long',
            });
            return formatter.format(new Date(this.forecastItem.time * 1000));
        },
        precipProbability() {
            if (this.forecastItem.precipProbability > 0.01) {
                return `${Math.round(this.forecastItem.precipProbability * 100)}%`;
            }
            return '';
        },
    },
    methods: {
        getIconPath(iconName) {
            return require(`../assets/icons/${iconName}.svg`); // eslint-disable-line
        },
    },
};
</script>

<style lang="scss">
.forecastItem__icon {
    width: 2rem;
    transform: scale(1.5);
}
</style>
